/**
 * URL della scheda orologio — UN SOLO POSTO NEL TEMA.
 * (2026-08-21)
 *
 * Le schede vivono nell'app: /a/orologi/{marca}/{modello}. Prima ogni pezzo del
 * tema se la componeva per conto suo verso /pages/watch-model/{modello}, e in un
 * caso verso /pages/{modello}, che non esisteva nemmeno: settanta collegamenti a
 * vuoto sulle pagine di misura, scoperti il 21/08.
 *
 * Sei posti che scrivono la stessa regola sono sei posti che possono divergere.
 * Da qui in avanti la regola sta qui, e chi ha bisogno di un indirizzo chiama
 * msOrologioUrl(marca, modello).
 *
 * Il prefisso di lingua lo mette Shopify (Shopify.routes.root vale '/' in
 * italiano e '/en/' in inglese): così da una pagina inglese si resta in inglese.
 */
(function () {
  function marca(nome) {
    return String(nome || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')   // «Söhne» → «sohne», «Glashütte» → «glashutte»
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  window.msOrologioUrl = function (nomeMarca, modello, prefisso) {
    var p = prefisso ||
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (p.charAt(p.length - 1) !== '/') p += '/';
    return p + 'a/orologi/' + marca(nomeMarca) + '/' + String(modello || '');
  };

  window.msOrologioMarcaSlug = marca;
})();
